// extracted by mini-css-extract-plugin
export var readonly = "_h2-1";
export var star = "_h2-0";